import React from 'react';
import Navigation from './src/navigation/Navigation';
import { ConfirmModal, ModalContainer } from './src/components';
import 'react-tippy/dist/tippy.css';
import './App.css';
import { AIAssistantChatBox } from './src/components/widgets/ai-assisstant/AIAssisstant';

export default function AppWeb() {
  return (
    <ModalContainer>
      <ConfirmModal>
        <Navigation />
        <AIAssistantChatBox />
      </ConfirmModal>
    </ModalContainer>
  );
}